import type { EventName } from "@lit/react";
import { Select as SelectElement, type SelectEventMap as _SelectEventMap, } from "@vaadin/select/vaadin-select.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SelectElement, };
export type SelectEventMap = Readonly<{
    onValidated: EventName<_SelectEventMap["validated"]>;
    onChange: EventName<_SelectEventMap["change"]>;
    onInvalidChanged: EventName<_SelectEventMap["invalid-changed"]>;
    onOpenedChanged: EventName<_SelectEventMap["opened-changed"]>;
    onValueChanged: EventName<_SelectEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInvalidChanged: "invalid-changed", onOpenedChanged: "opened-changed", onValueChanged: "value-changed" } as SelectEventMap;
export type SelectProps = WebComponentProps<SelectElement, SelectEventMap>;
export const Select = createComponent({
    elementClass: SelectElement, events, react: React, tagName: "vaadin-select"
});
